<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <!-- 데일리안 시절 개발사(Lever-T) 표기였다. 2026-09-25 에 중앙신문 CMS 개발사로 교체. -->
        <span>COPYRIGHT @ 2026 YoonTech, All rights Reserved</span>
        <span class="md:flex hidden items-center">
       </span>
    </footer>
</template>

<script>

export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    }
}
</script>
